var _g, _circle, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthStatusFail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4883 82.1306C11.2791 82.1306 9.48828 80.3398 9.48828 78.1306L9.48828 21.1982C9.48828 18.989 11.2791 17.1982 13.4883 17.1982L100.511 17.1982C102.721 17.1982 104.511 18.989 104.511 21.1982L104.511 78.1306C104.511 80.3398 102.72 82.1306 100.511 82.1306L13.4883 82.1306Z",
    fill: "url(#paint0_linear_10994_1920)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10994_1920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15332 101.135C4.94418 101.135 3.15332 99.3444 3.15332 97.1353L3.15332 32.2842C3.15332 30.0751 4.94418 28.2842 7.15332 28.2842L106.846 28.2842C109.055 28.2842 110.846 30.0751 110.846 32.2842L110.846 97.1353C110.846 99.3444 109.055 101.135 106.846 101.135L7.15332 101.135Z",
    fill: "url(#paint1_radial_10994_1920)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15332 100.635C5.22032 100.635 3.65332 99.0683 3.65332 97.1353L3.65332 32.2842C3.65332 30.3512 5.22032 28.7842 7.15332 28.7842L106.846 28.7842C108.779 28.7842 110.346 30.3512 110.346 32.2842L110.346 97.1353C110.346 99.0682 108.779 100.635 106.846 100.635L7.15332 100.635Z",
    stroke: "url(#paint2_linear_10994_1920)",
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1358 50.8372C30.0457 50.8372 26.73 54.1529 26.73 58.243C26.73 62.3331 30.0457 65.6488 34.1358 65.6488C38.2259 65.6488 41.5416 62.3331 41.5416 58.243C41.5416 54.1529 38.2259 50.8372 34.1358 50.8372ZM20.73 58.243C20.73 50.8391 26.732 44.8372 34.1358 44.8372C41.5396 44.8372 47.5416 50.8391 47.5416 58.243C47.5416 65.6468 41.5396 71.6488 34.1358 71.6488C26.732 71.6488 20.73 65.6468 20.73 58.243ZM20.73 81.2119C20.73 79.5551 22.0731 78.2119 23.73 78.2119H44.5416C46.1985 78.2119 47.5416 79.5551 47.5416 81.2119C47.5416 82.8688 46.1985 84.2119 44.5416 84.2119H23.73C22.0731 84.2119 20.73 82.8688 20.73 81.2119ZM57.7963 59.825C57.7963 58.1681 59.1394 56.825 60.7963 56.825H78.9727C80.6296 56.825 81.9727 58.1681 81.9727 59.825C81.9727 61.4818 80.6296 62.825 78.9727 62.825H60.7963C59.1394 62.825 57.7963 61.4818 57.7963 59.825ZM57.7965 73.0442C57.7965 71.3873 59.1396 70.0442 60.7965 70.0442H90.5397C92.1966 70.0442 93.5397 71.3873 93.5397 73.0442C93.5397 74.701 92.1966 76.0442 90.5397 76.0442H60.7965C59.1396 76.0442 57.7965 74.701 57.7965 73.0442Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.1429,
    cy: 82.2858,
    r: 14.3265,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10994_1920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.1429 60.8572C90.9048 60.8572 86.7618 62.1139 83.2379 64.4685C79.7139 66.8231 76.9674 70.1698 75.3455 74.0854C73.7236 78.0009 73.2993 82.3095 74.1261 86.4662C74.9529 90.623 76.9938 94.4412 79.9906 97.438C82.9875 100.435 86.8057 102.476 90.9624 103.303C95.1192 104.129 99.4277 103.705 103.343 102.083C107.259 100.461 110.606 97.7147 112.96 94.1908C115.315 90.6669 116.571 86.5239 116.571 82.2857C116.571 76.6025 114.314 71.1521 110.295 67.1335C106.277 63.1148 100.826 60.8572 95.1429 60.8572ZM105.75 89.8715L102.729 92.8929L95.1429 85.3072L87.5572 92.8929L84.5358 89.8715L92.1215 82.2857L84.5358 74.7L87.5572 71.6786L95.1429 79.2643L102.729 71.6786L105.75 74.7L98.1644 82.2857L105.75 89.8715Z",
    fill: "#FF5247"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10994_1920",
    x: -9.36711,
    y: 15.7638,
    width: 132.734,
    height: 97.8919,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.26021
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10994_1920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10994_1920",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10994_1920",
    x: 70.3144,
    y: 59.4572,
    width: 49.6569,
    height: 49.6572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14754 0 0 0 0 0.271122 0 0 0 0 0.310148 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10994_1920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10994_1920",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10994_1920",
    x1: 9.48828,
    y1: 45.7051,
    x2: 104.511,
    y2: 45.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10994_1920",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1579 98.7597) rotate(-40.3381) scale(130.896 94.9134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAFFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0FFF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10994_1920",
    x1: 31.8714,
    y1: 42.7027,
    x2: 82.5844,
    y2: 109.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#F1FFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1FFFC",
    stopOpacity: 0.06
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthStatusFail);
export default __webpack_public_path__ + "static/media/auth-status-fail.b0846d9c3159ace62a17c39f09a2c006.svg";
export { ForwardRef as ReactComponent };